import { LinkType } from '@sr/dto';
import { FormikErrors } from 'formik';
import { ICreateManagerLink } from '@sr/dto';

export interface FormData {
  userId: number | '';
  linkType: LinkType;
  endDate: Date;
}

export const toCreateDto = (companyId: number, values: FormData) => {
  const postData: ICreateManagerLink = {
    companyId,
    managerId: Number(values.userId),
    linkType: values.linkType,
    endDate: values.endDate,
  };
  return postData;
};

export const initialValues: FormData = {
  userId: '',
  linkType: 'link',
  endDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 30),
};

export const validate = (values: FormData) => {
  const errors: FormikErrors<FormData> = {};

  const requiredMsg = 'Поле обязательно';
  if (!values.userId) errors.userId = requiredMsg;

  if (!values.linkType) errors.linkType = requiredMsg;

  if (values.endDate && values.endDate < new Date()) {
    errors.endDate = 'Дата не может быть меньше текущей';
  }

  return errors;
};
